import { render, staticRenderFns } from "./LeadReviewMemberSetting.vue?vue&type=template&id=9fc964b2&scoped=true&"
import script from "./LeadReviewMemberSetting.vue?vue&type=script&lang=js&"
export * from "./LeadReviewMemberSetting.vue?vue&type=script&lang=js&"
import style0 from "./LeadReviewMemberSetting.vue?vue&type=style&index=0&id=9fc964b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc964b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})
